import React from "react";

const HeroSection = () => {
  return (
    <>
      <section
        className="fullscreen-banner banner banner-3 p-0 overflow-hidden bg-contain bg-pos-r animatedBackground "
        style={{
          height: "722px",
          backgroundImage: "url(../images/bg/05.png)",
        }}
      >
        <div className="insideText" style={{ top: "241px" }}>
          Brandnest
        </div>
        <div
          className="owl-carousel no-pb owl-loaded owl-drag"
          data-items="1"
          data-dots="false"
          data-autoplay="true"
        >
          <div className="owl-stage-outer">
            <div
              className="owl-stage"
              style={{
                transform: `translate3d(0px, 0px, 0px)`,
                transition: "all 1s ease 0s",
                width: "8516px",
              }}
            >
              <div className="owl-item active" style={{ width: "1419.2px" }}>
                <div className="item">
                  <div
                    className="align-center p-0"
                    style={{ paddingTop: "100px" }}
                  >
                    <div className="container">
                      <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12 order-lg-1">
                          <div
                            className="mouse-parallax info-img"
                            style={{
                              transform: "matrix(1, 0, 0, 1, -8.93333, 11.1)",
                            }}
                          >
                            <img
                              className="img-fluid animated1"
                              src="../images/home/hero-1.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12 mt-5 mt-lg-0">
                          <h1
                            className="mb-4 text animated2"
                            style={{ color: "#ff7810" }}
                          >
                            Empowering <br />
                            <span className="font-w-6 text-black">
                              Digitalization
                            </span>
                          </h1>
                          <p className="lead text-black animated3">
                            We talk digital!! <br />
                            We focus on driving potential customers by analyzing
                            market needs, <br /> advertising in the required
                            domain, and optimizing your digital space.
                          </p>
                          <div className="animated3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="owl-item " style={{ width: "1419.2px" }}>
                <div className="item">
                  <div
                    className="align-center p-0"
                    style={{ paddingTop: "100px" }}
                  >
                    <div className="container">
                      <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12 order-lg-1">
                          <div
                            className="mouse-parallax info-img"
                            style={{
                              transform: "matrix(1, 0, 0, 1, -8.93333, 11.1)",
                            }}
                          >
                            <img
                              className="img-fluid animated1"
                              src="../images/home/hero-2.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12 mt-5 mt-lg-0">
                          <h1
                            className="mb-4 text animated2"
                            style={{ color: "#ff7810" }}
                          >
                            Optimized{" "}
                            <span className="font-w-6 text-black">Digital</span>{" "}
                            Platform
                          </h1>
                          <p className="lead text-black animated3">
                            We talk digital!! <br />
                            We focus on driving potential customers by analyzing
                            market needs, advertising in the required domain,
                            and optimizing your digital space.
                          </p>
                          <div className="animated3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="owl-item" style={{ width: "1419.2px" }}>
                <div className="item">
                  <div
                    className="align-center p-0"
                    style={{ paddingTop: "100px" }}
                  >
                    <div className="container">
                      <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12 order-lg-1">
                          <div
                            className="mouse-parallax info-img"
                            style={{
                              transform: "matrix(1, 0, 0, 1, -8.93333, 11.1)",
                            }}
                          >
                            <img
                              className="img-fluid animated1"
                              src="../images/home/hero-3.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12 mt-5 mt-lg-0">
                          <h1
                            className="mb-4 text animated2"
                            style={{ color: "#ff7810" }}
                          >
                            Let’s Talk <br />{" "}
                            <span className="font-w-6 text-black">
                              Digital !!
                            </span>
                          </h1>
                          <p className="lead text-black animated3">
                            Analyze, Advertise, Optimize. Yes, We do it all!! We
                            focus on driving potential customers by analyzing
                            market needs, advertising in the required domain,
                            and optimizing your digital space.
                          </p>
                          <div className="animated3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="owl-item" style={{ width: "1419.2px" }}>
                <div className="item">
                  <div
                    className="align-center p-0"
                    style={{ paddingTop: "100px" }}
                  >
                    <div className="container">
                      <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12 order-lg-1">
                          <div
                            className="mouse-parallax info-img"
                            style={{
                              transform: "matrix(1, 0, 0, 1, -8.93333, 11.1)",
                            }}
                          >
                            <img
                              className="img-fluid animated1"
                              src="../images/home/hero-4.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12 mt-5 mt-lg-0">
                          <h1
                            className="mb-4 text animated2"
                            style={{ color: "#ff7810" }}
                          >
                            Analyze,{" "}
                            <span className="font-w-6 text-black">
                              Advertise, <br />{" "}
                            </span>{" "}
                            Optimize
                          </h1>
                          <p className="lead text-black animated3">
                            Blending the best of technology and marketing!! We
                            focus on driving potential customers by analyzing
                            market needs, <br /> advertising in the required
                            domain, and optimizing your digital space.
                          </p>
                          <div className="animated3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="owl-nav disabled">
            <button type="button" role="presentation" className="owl-prev">
              <span className="fas fa-long-arrow-alt-left">
                <span></span>
              </span>
            </button>
            <button type="button" role="presentation" className="owl-next">
              <span className="fas fa-long-arrow-alt-right"></span>
            </button>
          </div>
          <div className="owl-dots disabled"></div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
